export const SET_PARTENAIRES_ACAD_LOADING = "SET_PARTENAIRES_ACAD_LOADING";
export const SET_PARTENAIRES_ACAD_ERROR = "SET_PARTENAIRES_ACAD_ERROR";

export const FETCH_PARTENAIRES_ACAD_REQUEST = "FETCH_PARTENAIRES_ACAD_REQUEST";
export const FETCH_PARTENAIRES_ACAD_SUCCESS = "FETCH_PARTENAIRES_ACAD_SUCCESS";
export const FETCH_PARTENAIRES_ACAD_FAIL = "FETCH_PARTENAIRES_ACAD_FAIL";

export const CREATE_PARTENAIRE_ACAD_REQUEST = "CREATE_PARTENAIRE_ACAD_REQUEST";
export const CREATE_PARTENAIRE_ACAD_SUCCESS = "CREATE_PARTENAIRE_ACAD_SUCCESS";
export const CREATE_PARTENAIRE_ACAD_FAIL = "CREATE_PARTENAIRE_ACAD_FAIL";

export const UPDATE_PARTENAIRE_ACAD_REQUEST = "UPDATE_PARTENAIRE_ACAD_REQUEST";
export const UPDATE_PARTENAIRE_ACAD_SUCCESS = "UPDATE_PARTENAIRE_ACAD_SUCCESS";
export const UPDATE_PARTENAIRE_ACAD_FAIL = "UPDATE_PARTENAIRE_ACAD_FAIL";

export const DELETE_PARTENAIRE_ACAD_REQUEST = "DELETE_PARTENAIRE_ACAD_REQUEST";
export const DELETE_PARTENAIRE_ACAD_SUCCESS = "DELETE_PARTENAIRE_ACAD_SUCCESS";
export const DELETE_PARTENAIRE_ACAD_FAIL = "DELETE_PARTENAIRE_ACAD_FAIL";

export const setPartenairesAcadLoading = (v) => ({ type: SET_PARTENAIRES_ACAD_LOADING, payload: v });
export const setPartenairesAcadError = (msg) => ({ type: SET_PARTENAIRES_ACAD_ERROR, payload: msg });

export const fetchPartenairesAcadRequest = () => ({ type: FETCH_PARTENAIRES_ACAD_REQUEST });
export const fetchPartenairesAcadSuccess = (data) => ({ type: FETCH_PARTENAIRES_ACAD_SUCCESS, payload: data });
export const fetchPartenairesAcadFail = (err) => ({ type: FETCH_PARTENAIRES_ACAD_FAIL, payload: err });

export const createPartenaireAcadRequest = (payload) => ({ type: CREATE_PARTENAIRE_ACAD_REQUEST, payload });
export const createPartenaireAcadSuccess = (data) => ({ type: CREATE_PARTENAIRE_ACAD_SUCCESS, payload: data });
export const createPartenaireAcadFail = (err) => ({ type: CREATE_PARTENAIRE_ACAD_FAIL, payload: err });

export const updatePartenaireAcadRequest = (id, payload) => ({
    type: UPDATE_PARTENAIRE_ACAD_REQUEST,
    payload: { id, payload },
});
export const updatePartenaireAcadSuccess = (data) => ({ type: UPDATE_PARTENAIRE_ACAD_SUCCESS, payload: data });
export const updatePartenaireAcadFail = (err) => ({ type: UPDATE_PARTENAIRE_ACAD_FAIL, payload: err });

export const deletePartenaireAcadRequest = (id) => ({ type: DELETE_PARTENAIRE_ACAD_REQUEST, payload: { id } });
export const deletePartenaireAcadSuccess = (id) => ({ type: DELETE_PARTENAIRE_ACAD_SUCCESS, payload: id });
export const deletePartenaireAcadFail = (err) => ({ type: DELETE_PARTENAIRE_ACAD_FAIL, payload: err });
